var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VPopup",
    {
      staticClass: "keymap-settings-popup be-settings-extra-options",
      attrs: { fixed: "", "trigger-element": _vm.triggerElement },
      model: {
        value: _vm.popupOpen,
        callback: function ($$v) {
          _vm.popupOpen = $$v
        },
        expression: "popupOpen",
      },
    },
    [
      _c("div", { staticClass: "keymap-settings" }, [
        _c("div", { staticClass: "keymap-settings-header" }, [
          _c(
            "div",
            { staticClass: "keymap-settings-header-title" },
            [
              _c("VIcon", { attrs: { icon: "mdi-keyboard-settings-outline" } }),
              _vm._v("\n        快捷键设置\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "keymap-settings-header-help",
              attrs: {
                href: "https://github.com/the1812/Bilibili-Evolved/blob/preview/registry/lib/components/utils/keymap/help.md",
                target: "_blank",
                title: "查看帮助",
              },
            },
            [
              _c("VIcon", {
                attrs: { size: 18, icon: "mdi-help-circle-outline" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "keymap-settings-header-close",
              attrs: { title: "关闭" },
            },
            [
              _c("VIcon", {
                attrs: { size: 18, icon: "close" },
                on: {
                  click: function ($event) {
                    _vm.popupOpen = false
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "keymap-settings-content" }, [
          _c(
            "div",
            { staticClass: "keymap-settings-grid" },
            [
              _c("div", { staticClass: "grid-header" }, [
                _c("div", { staticClass: "header-name" }, [_vm._v("动作")]),
                _vm._v(" "),
                _c("div", { staticClass: "header-default-binding" }, [
                  _vm._v("默认按键"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-preset-binding" },
                  [
                    _c("VDropdown", {
                      attrs: {
                        items: _vm.presetOptions,
                        "key-mapper": (it) => it,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item) +
                                  "\n              "
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selectedPreset,
                        callback: function ($$v) {
                          _vm.selectedPreset = $$v
                        },
                        expression: "selectedPreset",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "header-custom-binding" }, [
                  _vm._v("自定义按键"),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.rows, function (row) {
                return _c("KeymapSettingsRow", {
                  key: row.name,
                  attrs: { row: row, "selected-preset": _vm.selectedPreset },
                })
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }